module.exports = __webpack_public_path__ + "static/media/QuestionCircle.5724e19c.svg";